import React from 'react';
import JSZip from 'jszip';
import FileSaver from 'file-saver';
import AppBlobCache from './AppBlobCache'
import GlobalStorage from './component_tbc_editor/storage/GlobalStorage';
import axios from 'axios' 
import confirm from "reactstrap-confirm";

var TableExport = null;

if (typeof window !== `undefined`)
{
  TableExport = require("tableexport").TableExport;
}

let instance = null;

export default class AppZipCreator
{
  constructor()
  {
    if (!instance) {
      instance = this;
    }

    instance.blobs = instance.blobs || {};
    return instance;
  }
  
  generateZip(jsonRaw, jsonExcel, projectName,callback)
  {
    let zip = new JSZip();
    let cache = new AppBlobCache();
    let blobs = cache.getMediaBlobs();    
    var keys = [];
    for (var key in blobs) {
      keys.push(key);
    }
    
    this.fulfillZipWithJSON(zip, keys, blobs, Object.assign({}, jsonRaw),projectName);      
    this.fulfillZipWithExcel(zip, keys, blobs, Object.assign({}, jsonExcel),projectName);
    this.fulfillZipWithBlobs(zip, keys, blobs, 0, projectName, () => {
      if (global.DEBUG){console.log(zip);}
      zip.generateAsync({type: "blob"}).then(function(content) {
        if (global.DEBUG){console.log(content);}          
          callback(content,projectName)

          /*var GS = new GlobalStorage();                              
          var request = new XMLHttpRequest();
          request.open("POST", "http://dev.web-gineer.com/TBC-email/save.php");
          request.onload = function(e) {                        
            console.log(request.responseText);
            var m_data = new FormData();   
            m_data.append('name', GS.getStoryEpisode().author);
            m_data.append('projectName', GS.getStoryEpisode().project_name);
            m_data.append('email_address', GS.getStoryEpisode().email);
            m_data.append('file_name', request.responseText);                        
            var global_oreq = new XMLHttpRequest();

            global_oreq.open("POST", 'http://dev.web-gineer.com/TBC-email/index.php', true);
            global_oreq.onload = function(e) {                
                if (global_oreq.responseText==1){
                  //alert("你的故事已經送到TBC的團隊! 我們會盡快䏈絡你。");                
                }
            };                        
            global_oreq.send(m_data);
          };                    
          request.send(content);*/
          if (global.DEBUG) FileSaver.saveAs(content, projectName+".zip");
          //FileSaver.saveAs(content, projectName+".zip");
          
      });
    });
      
  }

  generateZipWithBlobCache(jsonRaw, jsonExcel, projectName)
  {
    this.generateZip(jsonRaw, jsonExcel, projectName,(content,projectName)=>{
      FileSaver.saveAs(content, projectName+".zip");
    })    
  }

  generateEmail(jsonRaw, jsonExcel,projectName)
  {
    this.generateZip(jsonRaw, jsonExcel, projectName,(content,projectName)=>{                                
        var GS = new GlobalStorage();                              
        var request = new XMLHttpRequest();
        request.open("POST", "http://dev.web-gineer.com/TBC-email/save.php");
        request.onload = function(e) {                        
          console.log(request.responseText);
          var m_data = new FormData();   
          m_data.append('name', GS.getStoryEpisode().author);
          m_data.append('projectName', GS.getStoryEpisode().project_name);
          m_data.append('email_address', GS.getStoryEpisode().email);
          m_data.append('file_name', request.responseText);                        
          var global_oreq = new XMLHttpRequest();

          global_oreq.open("POST", 'http://dev.web-gineer.com/TBC-email/index.php', true);
          global_oreq.onload = function(e) {                
              if (global_oreq.responseText==1)
                alert("你的故事已經送到TBC的團隊! 我們會盡快䏈絡你。");                
          };                        
          global_oreq.send(m_data);
        };                    
        request.send(content);                                            
      });      
  }

  createStory()
  {
    var GS = new GlobalStorage();                              
   
    let formData = new FormData();
    formData.append('uuid',GS.getStory().uuid);
    formData.append('storyName',GS.getStory().storyName);
    formData.append('author',GS.getStory().author);
    formData.append('description',GS.getStory().description);
    if (document.getElementById("story-cover-image").files[0] !== undefined) {
      formData.append('coverImage', document.getElementById("story-cover-image").files[0]);
    }
    formData.append('shareUrl',"");
    formData.append('defaultShareUrl','true')
    formData.append('warningList','[%22%22,%20%22SOUND%22]');
    formData.append('additionalInfoList','[{%22label%22%20:%20%22Additional%20Info%22,%20%22url%22%20:%20%22Additional%20Info%20URL%22}]');
    formData.append('category',GS.getStory().category);
    
    
    
    
    formData.append('backOnCount','0');
    formData.append('type',"RELEASED");
    formData.append('stage',"RELEASE");
    formData.append('status',"ACTIVE");
    formData.append('suggested',false);
    formData.append('storyEndingCTAMap','{"CONTINUING" : {"sign" : {}, "message" : [{"author" : "Giotto", "content" : "Story Ending CTA"}], "buttonList" : [{"type" : "COMMENT", "action":""}]}}');
    //formData.append('enablePush',false);

    axios({
      method: 'post',
      url: global.CMS_URL+'admin/stories/'+GS.getStory().uuid,
      data: formData,
      headers: {
        Authorization: GS.getUser().token 
      }
    })
    .then(response => {
      GS.getStory().uuid = response.data;
      alert("已創立故事！馬上創立故事章節！")
      if (global.DEBUG) console.log(GS.getStory().uuid);      
    })
    .catch(error => {        
      console.log(error)
    })
  }

  createEpisode(callback)
  {
    var GS = new GlobalStorage();                              
    let formData = new FormData()


    var storyUuid=GS.getStory().uuid;
    var episodeUuid=GS.getStoryEpisode().uuid;
    
    if (GS.getStoryEpisode().coverImage) {
      formData.append('image', GS.getStoryEpisode().coverImage)
    }
    /*
    //formData.append('episodeUuid', null)
    formData.append('storyUuid', storyUuid)
    formData.append('title', GS.getStoryEpisode().project_name)
    formData.append('sequence', GS.getStoryEpisode().sequence)
    //formData.append('publishState', "第N集")
    formData.append('publishAt', new Date().toISOString())    
    formData.append('enablePush',false);    
*/
//var agree = window.prompt("請先同意及接受tbc的「使用條款及細則」和「私穩政策」","同意");
let result =  confirm(
  {
    title: (
        "同意及接受使用條款及細則"
    ),
      message: (<span>請先同意及接受tbc的「<a href="https://tbcstory.com/tnc.html" target="_blank">使用條款及細則</a>」和「<a href="https://tbcstory.com/tnc.html" target="_blank">私穩政策</a>」</span>),
      confirmText: "同意",
      cancelText: "取消",
      confirmColor: "primary",          
  }
).then((result)=>{
  if (result){

    if (episodeUuid==='')
    {
        var dateOffset = (60*1000) * 0; //5 minute, delay for testing purpose only
        var myDate = new Date();
        myDate.setTime(myDate.getTime() + dateOffset);
        var URL_params={
          storyUuid:storyUuid,
          title:GS.getStoryEpisode().project_name,
          sequence:GS.getStoryEpisode().sequence,
          publishState:"PUBLISHED",
          publishAt:myDate.toISOString().split('.')[0]+"Z"
        }

        axios({
          method: 'post',
          url: global.CMS_URL+'admin/stories/' + storyUuid + '/episode/',
          data: formData,
          params:URL_params,
          headers: {
            Authorization: GS.getUser().token
          }
        })
        .then(response => {
          if (global.DEBUG) console.log(response.data)
          this.generateZip(GS.getStoryEpisode(), GS.parseStoryEpisodeItemsToJsonObject(),GS.getStoryEpisode().project_name,(content,projectName)=>{                                                            
            let formData = new FormData();
            formData.append('file', content);          
            formData.append('type', 'STORY');         
            var episodeUuid=response.data;
            axios({
              method: 'post',
              url: global.CMS_URL+'admin/stories/' + storyUuid + '/episode/' + episodeUuid + '/upload-zip',
              headers: {
                'Content-Type': 'text/plain',
                Authorization: GS.getUser().token
              },
              responseType: 'arraybuffer',
              data: formData
            }).then((response) => {              
              if (global.DEBUG) console.log(response);
              callback()
            })
              .catch(function (error) {
                console.log(error)
              })
            }                                         
          );      
          
        })
        .catch(error => {        
          console.log(error)
        })
    }else
    {
      this.generateZip(GS.getStoryEpisode(), GS.parseStoryEpisodeItemsToJsonObject(),GS.getStoryEpisode().project_name,(content,projectName)=>{                                                            
        let formData = new FormData();
        formData.append('file', content);            
        formData.append('type', 'STORY');
        axios({
          method: 'post',
          url: global.CMS_URL+'admin/stories/' + storyUuid + '/episode/' + episodeUuid + '/upload-zip',
          headers: {
            'Content-Type': 'text/plain',
            Authorization: GS.getUser().token
          },
          responseType: 'arraybuffer',
          data: formData
        }).then((response) => {              
          if (global.DEBUG) console.log(response);
          callback()
        })
          .catch(function (error) {
            console.log(error)
          })
        }                                         
      );    
    }
  }
  });
}


  fulfillZipWithBlobs(zip, keys, blobs, cursor, projectName, callback)
  {
    if (keys.length > cursor)
    {
      var self = this;
      var blob = blobs[keys[cursor]];
      var xhr = new XMLHttpRequest();
      xhr.open('GET', blob.blob_url, true);
      xhr.responseType = 'blob';
      xhr.onload = function(e) {
        if (this.status == 200) {
          var myBlob = this.response;
          if (keys[cursor]==projectName){
            //zipping xlsx
            zip.file(`${blob.filename}.${blob.ext}`, myBlob,{binary: true});
          }else{
            var folder ='';
            switch (blob.ext){
              case "mp4":
                folder='video';
              break;
              case "mp3":
                folder='sound';
              break;
              case "jpg":
              case "jpeg":
              case "png":
                folder='image';
              break;
            }
            zip.folder(`media/`+folder).file(`${blob.filename}.${blob.ext}`, myBlob);
          }          
          cursor += 1;
          self.fulfillZipWithBlobs(zip, keys, blobs, cursor,projectName,callback);
        }
      };
      xhr.send();
    }
    else
    {
      callback();
    }
  }


  fulfillZipWithJSON(zip, keys, blobs, json, projectName)
  {
    var file = new File([JSON.stringify(json)], projectName+".json", {type: "text/plain;charset=utf-8"});
    alert("注意！若故事需要修改，可重載json檔。");
    FileSaver.saveAs(file);
    
  }


  createChannelEpisode(html, projectName,callback,cancelCallback){
    var GS = new GlobalStorage();                              
    var storyUuid=GS.getStory().uuid;
    var episodeUuid=GS.getStoryEpisode().uuid;
    
    let formData = new FormData()
    let result =  confirm(
      {
        title: (
            "同意及接受使用條款及細則"
        ),
          message: (<span>請先同意及接受tbc的「<a href="https://tbcstory.com/tnc.html" target="_blank">使用條款及細則</a>」和「<a href="https://tbcstory.com/tnc.html" target="_blank">私穩政策</a>」</span>),
          confirmText: "同意",
          cancelText: "取消",
          confirmColor: "primary",          
      }
    ).then((result)=>{
      if (result)
      {

        var file = new File([GS.getHtml()], GS.getStoryEpisode().project_name+".html", {type: "text/html;charset=utf-8"});    
        FileSaver.saveAs(file);

        if (GS.getStoryEpisode().coverImage) {
          formData.append('image', GS.getStoryEpisode().coverImage)
        }
        if (episodeUuid==='')
        {

          
          var myDate = new Date(GS.getStoryEpisode().publishDate+"T"+GS.getStoryEpisode().publishTime);
        

          var URL_params={
            storyUuid:storyUuid,
            title:GS.getStoryEpisode().project_name,
            sequence:GS.getStoryEpisode().sequence,      
            freePreview:GS.getStoryEpisode().freePreview,      
            publishState:"PUBLISHED",
            publishAt:myDate.toISOString().split('.')[0]+"Z"
          }

          axios({
            method: 'post',
            url: global.CMS_URL+'admin/stories/' + storyUuid + '/episode/',
            data: formData,
            params:URL_params,
            headers: {
              Authorization: GS.getUser().token
            }
          })
          .then(response => {
            this.generateHTMLZip(html, projectName,(content,projectName)=>{                                                            
                let formData = new FormData();
                formData.append('file', content);
                formData.append('type', 'WEB_CONTENT');
                var episodeUuid=response.data;              
                axios({
                  method: 'post',
                  url: global.CMS_URL+'admin/stories/' + storyUuid + '/episode/' + episodeUuid + '/upload-zip',
                  headers: {
                    'Content-Type': 'text/plain',
                    Authorization: GS.getUser().token
                  },
                  responseType: 'arraybuffer',
                  data: formData
                }).then((response) => {              
                  if (global.DEBUG) console.log(response);
                  callback()
                })
                  .catch(function (error) {
                    console.log(error)
                  })
                }                                         
              );    
            }
          );
        }else
        {
          this.generateHTMLZip(html, projectName,(content,projectName)=>{                                                            
            let formData = new FormData();
            formData.append('file', content);
            formData.append('type', 'WEB_CONTENT');            
            axios({
              method: 'post',
              url: global.CMS_URL+'admin/stories/' + storyUuid + '/episode/' + episodeUuid + '/upload-zip',
              headers: {
                'Content-Type': 'text/plain',
                Authorization: GS.getUser().token
              },
              responseType: 'arraybuffer',
              data: formData
            }).then((response) => {              
              if (global.DEBUG) console.log(response);
              callback()
            })
              .catch(function (error) {
                console.log(error)
              })
            }                                         
          );    
        }

      }else
      {
        cancelCallback();
      }
    }
    );
  }


  generateHTMLZip(html, projectName,callback)
  {
    let zip = new JSZip();
    const keys = null;
    const blobs = null;
    // this.fulfillZipWithJSON(zip, keys, blobs, Object.assign({}, jsonRaw),projectName);      

    this.fulfillZipWithHTML(zip, keys, blobs, html,projectName,()=>{
      if (global.DEBUG){console.log(zip);}
      zip.generateAsync({type: "blob"}).then(function(content) {
        if (global.DEBUG){console.log(content);}          
          callback(content,projectName);          
          if (global.DEBUG) FileSaver.saveAs(content, projectName+".zip");
          //FileSaver.saveAs(content, projectName+".zip");
          
      });
    });                  
  }
  
  fulfillZipWithHTML(zip, keys, blobs, html, projectName, callback)
  {
    var file = new File([html], "index.html", {type: "text/html;charset=utf-8"});    
    // FileSaver.saveAs(file);   
    //template processing
    zip.folder(projectName+`/`).file("index.html", file);    
    callback();     
  }
  


  fulfillZipWithExcel(zip, keys, blobs, json, projectName)
  {
    if (global.DEBUG) console.log(json);

    

/*
    var tableinner = `
    <tbody>
<tr>
<td rowspan="4" height="76">Type</td>
<td rowspan="4">Style</td>
<td rowspan="4">Position</td>
<td colspan="17" rowspan="2" width="1020">Content</td>
<td rowspan="4">Animation</td>
<td rowspan="4">Vibration</td>
<td rowspan="4">AllowSkip</td>
<td rowspan="4">AutoDismiss</td>
<td colspan="3" rowspan="2" width="180">Background</td>
<td colspan="2" rowspan="3" width="120">Sound</td>
<td colspan="18" width="1080">Overlay</td>
</tr>
<tr>
<td colspan="8" height="19">Content</td>
<td rowspan="3">Animation</td>
<td colspan="3">Background</td>
<td colspan="2">Sound</td>
<td rowspan="3">Vibration</td>
<td rowspan="3">Timing</td>
<td rowspan="3">AllowSkip</td>
<td rowspan="3">AutoDismiss</td>
</tr>
<tr style="height: 14.0pt;">
<td style="height: 14.0pt;" height="19">Name</td>
<td>Text</td>
<td colspan="3">Url</td>
<td colspan="2">Primary Media</td>
<td colspan="2">Secondary Media</td>
<td colspan="4">Text</td>
<td colspan="3">Name</td>
<td rowspan="2">Color</td>
<td rowspan="2">Color</td>
<td colspan="2">Media</td>
<td colspan="5">Text</td>
<td colspan="2">Media</td>
<td rowspan="2">Position</td>
<td rowspan="2">Color</td>
<td colspan="2">Media</td>
<td rowspan="2">File</td>
<td rowspan="2">Loop</td>
</tr>
<tr style="height: 14.0pt;">
<td style="height: 14.0pt;" height="19">Value</td>
<td>Value</td>
<td>Value</td>
<td>Show</td>
<td>Color</td>
<td>Type</td>
<td>File</td>
<td>Type</td>
<td>File</td>
<td>Style</td>
<td>Size</td>
<td>Color</td>
<td>Animation</td>
<td>Style</td>
<td>Size</td>
<td>Color</td>
<td>Type</td>
<td>File</td>
<td>File</td>
<td>Loop</td>
<td>Value</td>
<td>Style</td>
<td>Size</td>
<td>Color</td>
<td>Animation</td>
<td>Type</td>
<td>File</td>
<td>Type</td>
<td>File</td>
</tr>


${
        (() => {
          var items = [];
          if (json.scenes && json.scenes.scene)
          {
            for (var k in json.scenes.scene)
            {
              var scene = json.scenes.scene[k];
              items.push(`<tr><td>START</td></tr>`)
              items.push(`<tr><td>content</td><td>message</td></tr>`)

              if (scene && scene.items && scene.items.item)
              {
                for (var m in scene.items.item)
                {
                  var item = scene.items.item[m];

                  var primary_media = null;
                  var secondary_media = null;
                  
                  if (item.bg && item.bg.enabled)
                  {
                    if (item.bg._attributes.type === 'image')
                    {
                      primary_media = 'image'
                    }
                    else if (item.bg._attributes.type === 'video')
                    {
                      primary_media = 'video'
                    }
                    
                    if (item.sound && item.sound.enabled)
                    {
                      secondary_media = 'sound'
                    }
                  }
                  else if (item.sound && item.sound.enabled)
                  {
                    primary_media = 'sound';
                  }

                  if (item.text && item.text._attributes && item.text._attributes.size)
                  {
                    if (item.text._attributes.size === 'small')
                    {
                      item.text._attributes.size = 18;
                    }
                    else if (item.text._attributes.size === 'medium')
                    {
                      item.text._attributes.size = 22;
                    }
                    else if (item.text._attributes.size === 'large')
                    {
                      item.text._attributes.size = 26;
                    }
                    else if (item.text._attributes.size === 'xlarge')
                    {
                      item.text._attributes.size = 30;
                    }
                  }

                  if (item.name && item.name._attributes && item.name._attributes.size)
                  {
                    if (item.name._attributes.size === 'small')
                    {
                      item.name._attributes.size = 18;
                    }
                    else if (item.name._attributes.size === 'medium')
                    {
                      item.name._attributes.size = 22;
                    }
                    else if (item.name._attributes.size === 'large')
                    {
                      item.name._attributes.size = 26;
                    }
                    else if (item.name._attributes.size === 'xlarge')
                    {
                      item.name._attributes.size = 30;
                    }
                  }                  

                  items.push(`
                    <tr>
                    <td>${item._attributes.type}</td>
                    <td>${item._attributes.style}</td>
                    <td>${item._attributes.position && item._attributes.position.toUpperCase()}</td>
                    <td>${item.name && item.name.enabled && item.name._text}</td>
                    <td>${item.text && item.text.enabled && item.text._text}</td>
                    <td></td>
                    <td></td>
                    <td>#00ff00</td>
                    
                    ${
                      (primary_media === 'image' || primary_media === 'video') ? `
                    <td>${item.bg._attributes.type}</td>
                    <td>${item.bg._attributes.src}</td>
                    ` : null
                      }

                    ${
                      (primary_media === 'sound') ? `
                    <td>${`sound`}</td>
                    <td>${item.sound._attributes.src}</td>
                    ` : null
                      }
                           
                    
                    ${
                      (!primary_media) ? `
                    <td></td>
                    <td></td>
                    ` : null
                      }       
                     
                     
                    
                    ${
                      (secondary_media === 'image' || secondary_media === 'video') ? `
                    <td>${item.bg._attributes.type}</td>
                    <td>${item.bg._attributes.src}</td>
                    ` : null
                      }

                    ${
                      (secondary_media === 'sound') ? `
                    <td>${`sound`}</td>
                    <td>${item.sound._attributes.src}</td>
                    ` : null
                      }
                           
                    
                    ${
                      (!secondary_media) ? `
                    <td></td>
                    <td></td>
                    ` : null
                      }       
                            
                                    
                            
                    <td>${  (item.text && item.text._attributes && item.text._attributes.style)  ||  '' }</td>
                    <td>${  (item.text && item.text._attributes && item.text._attributes.size)  ||  '' }</td>
                    <td>${  (item.text && item.text._attributes && item.text._attributes.color)  ||  '' }</td>
                    <td>${  (item.text && item.text._attributes && item.text._attributes.anim)  ||  '' }</td>

                    <td>${  (item.name && item.name._attributes && item.name._attributes.style)  ||  '' }</td>
                    <td>${  (item.name && item.name._attributes && item.name._attributes.size)  ||  '' }</td>
                    <td>${  (item.name && item.name._attributes && item.name._attributes.color)  ||  '' }</td>
                    
                    <td>${  (item._attributes && item._attributes.itemColor)   ||   '' }</td>
                    <td>${  (item._attributes && item._attributes.anim ? 'fade' : '')   ||   '' }</td>
                    <td>${  (item._attributes && item._attributes.vibration ? 'y' : '')   ||   '' }</td>
                    <td>${  (item._attributes && item._attributes.allowSkip === 'true' ? 'y' : '')   ||   '' }</td>
                    <td>${  (item._attributes && item._attributes.autoDismiss === 'true' ? 'y' : '')   ||   '' }</td>
                    

                    <td>${ (!item.bg || !item.bg.enabled) ? ''  :  (item.bg._attributes.color)  }</td>
                    <td>${ (!item.bg || !item.bg.enabled) ? ''  :  (item.bg._attributes.color ? 'color' : item.bg._attributes.type)  }</td>
                    <td>${ (!item.bg || !item.bg.enabled) ? ''  :  (item.bg._attributes.color ? item.bg._attributes.color : item.bg._attributes.src)  }</td>

                    <td>${ (!item.sound || !item.sound.enabled) ? ''  :  (item.sound._attributes.src)  }</td>
                    <td>${ (!item.sound || !item.sound.enabled) ? ''  :  (item.sound._attributes.loop)  }</td>

                    ${ (!item.overlay ) ? `
                      <td>
                      </td>
                      <td>
                      </td>
                      <td>
                      </td>
                      <td>
                      </td>
                      <td>
                      </td>
                      `  :  `
                      <td>${item.text && item.text.enabled && item.text._text}</td>
                      <td>${item.text && item.text._attributes && item.text._attributes.style}</td>
                      <td>${item.text && item.text._attributes && item.text._attributes.size}</td>
                      <td>${item.text && item.text._attributes && item.text._attributes.color}</td>
                      <td>${item.text && item.text._attributes && item.text._attributes.anim}</td>
                    `}
                      
                      
                      
                    
                    ${ (!item.overlay || !item.overlay.media || !item.overlay.media._attributes ) ? `
                      <td>
                      </td>
                      <td>
                      </td>
                      `  :  `
                      <td>${item.overlay.media._attributes && item.overlay.media._attributes.type}</td>
                      <td>${item.overlay.media._attributes && item.overlay.media._attributes.src}</td>
                    `}
                                          
                                          
                                          
                    ${ (!item.overlay ) ? `
                      <td>
                      </td>
                      <td>
                      </td>
                      `  :  `
                      <td>${item.overlay._attributes && item.overlay._attributes.position}</td>
                      <td>${item.overlay._attributes && item.overlay._attributes.anim}</td>
                    `}
                    
                    
                                          
                    ${ (!item.overlay ) ? `
                      <td>
                      </td>
                      <td>
                      </td>
                      <td>
                      </td>
                      <td>
                      </td>
                      <td>
                      </td>
                      `  :  `
                      <td>${ (!item.bg || !item.bg.enabled) ? ''  :  (item.bg._attributes.color)  }</td>
                      <td>${ (!item.bg || !item.bg.enabled) ? ''  :  (item.bg._attributes.color ? 'color' : item.bg._attributes.type)  }</td>
                      <td>${ (!item.bg || !item.bg.enabled) ? ''  :  (item.bg._attributes.color ? item.bg._attributes.color : item.bg._attributes.src)  }</td>
  
                      <td>${ (!item.sound || !item.sound.enabled) ? ''  :  (item.sound._attributes.src)  }</td>
                      <td>${ (!item.sound || !item.sound.enabled) ? ''  :  (item.sound._attributes.loop)  }</td>

                    `}
                    
                    
                    
                                          
                    ${ (!item.overlay ) ? `
                      <td>
                      </td>
                      <td>
                      </td>
                      <td>
                      </td>
                      <td>
                      </td>
                      `  :  `
                      <td>${item.overlay._attributes && item.overlay._attributes.vibration ? 'y' : ''}</td>
                      <td>${item.overlay._attributes && item.overlay._attributes.timing ? 'fade' : ''}</td>
                      <td>${item.overlay._attributes && item.overlay._attributes.allowSkip === 'true' ? 'y' : ''}</td>
                      <td>${item.overlay._attributes && item.overlay._attributes.autoDismiss === 'true' ? 'y' : ''}</td>
                    `}
                      
                    </tr>
                  `)
                }
              }

              items.push(`<tr><td>END</td></tr>`)
            }
          }
          return items;
        })().join(',')
        }

</tbody>  
    `;

    var template = document.createElement('table');
    template.setAttribute('id', 'table-default');
    template.innerHTML = (`
<style type="text/css">
	table.table-default {
		font-size: 12px;
		border: 1px solid #CCC; 
		font-family: Arial, Helvetica, sans-serif;
	} 
	.table-default td {
		padding: 4px;
		margin: 3px;
		border: 1px solid #CCC;
	}
	.table-default th {
		background-color: #104E8B; 
		color: #FFF;
		font-weight: bold;
	}
</style>
${tableinner}
    `);


    if (typeof window !== `undefined` && TableExport)
    {
      var te = new TableExport(template, {
        headers: true,                              // (Boolean), display table headers (th or td elements) in the <thead>, (default: true)
        footers: true,                              // (Boolean), display table footers (th or td elements) in the <tfoot>, (default: false)
        formats: ['xlsx', 'csv', 'txt'],            // (String[]), filetype(s) for the export, (default: ['xlsx', 'csv', 'txt'])
        filename: 'id',                             // (id, String), filename for the downloaded file, (default: 'id')
        bootstrap: false,                           // (Boolean), style buttons using bootstrap, (default: false)
        position: 'bottom',                         // (top, bottom), position of the caption element relative to table, (default: 'bottom')
        ignoreRows: null,                           // (Number, Number[]), row indices to exclude from the exported file(s) (default: null)
        ignoreCols: null,                           // (Number, Number[]), column indices to exclude from the exported file(s) (default: null)
        ignoreCSS: '.tableexport-ignore',           // (selector, selector[]), selector(s) to exclude cells from the exported file(s) (default: '.tableexport-ignore')
        emptyCSS: '.tableexport-empty',             // (selector, selector[]), selector(s) to replace cells with an empty string in the exported file(s) (default: '.tableexport-empty')
        trimWhitespace: true,                       // (Boolean), remove all leading/trailing newlines, spaces, and tabs from cell text in the exported file(s) (default: true)
        RTL: false,                                 // (Boolean), set direction of the worksheet to right-to-left (default: false)
        sheetname: 'id',                             // (id, String), sheet name for the exported spreadsheet, (default: 'id')
        buttons: false,
      });
      var exportData = te.getExportData()['table-default']['xlsx'];
      te.export2file(exportData.data, exportData.mimeType, exportData.filename, exportData.fileExtension);
    }
*/
      const XLSX = require("xlsx");
      

      var wb = {
        SheetNames:["Sheet1"],
        Sheets: {
          Sheet1: {
            "!ref": "A1:AU4",
            A1:{t:'s', v:"Type"},
            B1:{t:'s', v:"Style"},
            C1:{t:'s', v:"Position"},
/* START CONTENT */
            D1:{t:'s', v:"Content"},

            D3:{t:'s', v:"Name"},
            D4:{t:'s', v:"Value"},
            E3:{t:'s', v:"Text"},
            E4:{t:'s', v:"Value"},
            
            F3:{t:'s', v:"URL"},
            F4:{t:'s', v:"Value"},
            G4:{t:'s', v:"Show"},
            H4:{t:'s', v:"color"},

            I3:{t:'s', v:"Primary Media"},
            I4:{t:'s', v:"Type"},
            J4:{t:'s', v:"File"},            

            K3:{t:'s', v:"Secondary Media"},
            K4:{t:'s', v:"Type"},
            L4:{t:'s', v:"File"},
            
            M3:{t:'s', v:"Text"},
            M4:{t:'s', v:"Style"},
            N4:{t:'s', v:"Size"},
            O4:{t:'s', v:"Color"},

            P4:{t:'s', v:"Animation"},

            Q3:{t:'s', v:"Name"},
            Q4:{t:'s', v:"Style"},
            R4:{t:'s', v:"Size"},
            S4:{t:'s', v:"Color"},

            T3:{t:'s', v:"Color"},        

            U1:{t:'s', v:"Animation"},        
            V1:{t:'s', v:"Vibration	"},        
            W1:{t:'s', v:"AllowSkip"},        
            X1:{t:'s', v:"AutoDismiss"},        
/* END CONTENT */  
/* START BACKGROUND */            
            Y1:{t:'s', v:"Background"},        
            Y3:{t:'s', v:"Color"},        
            Z3:{t:'s', v:"Media"},        
            Z4:{t:'s', v:"Type"},        
            AA4:{t:'s', v:"File"},        
/* END BACKGROUND */            

/* START SOUND */            
            AB1:{t:'s', v:"Sound"},        
            AB4:{t:'s', v:"File"},        
            AC4:{t:'s', v:"Loop"},                    
/* END SOUND */            


/* START OVERLAY */
            AD1:{t:'s', v:"Overlay"},

            AD2:{t:'s', v:"Content"},
            AD3:{t:'s', v:"Text"},
            AD4:{t:'s', v:"Value"},
            AE4:{t:'s', v:"Style"},
            AF4:{t:'s', v:"Size"},
            AG4:{t:'s', v:"Color"},
            AH4:{t:'s', v:"Animation"},

            AI3:{t:'s', v:"Media"},
            AI4:{t:'s', v:"Type"},
            AJ4:{t:'s', v:"File"},            
            AK3:{t:'s', v:"Position"},

            AL2:{t:'s', v:"Animation"},

            AM2:{t:'s', v:"Background"},
            AM3:{t:'s', v:"Color"},
            AN3:{t:'s', v:"Media"},
            AN4:{t:'s', v:"Type"},
            AO4:{t:'s', v:"File"},

            AP2:{t:'s', v:"Sound"},
            AP3:{t:'s', v:"File"},
            AQ3:{t:'s', v:"Loop"},

            AR2:{t:'s', v:"Vibration"},        
            AS2:{t:'s', v:"Timing"},        
            AT2:{t:'s', v:"AllowSkip"},        
            AU2:{t:'s', v:"AutoDismiss"},        
        

            "!merges":[
              {s:{r:0,c:0},e:{r:3,c:0}, /* A1:A3 */},
              {s:{r:0,c:1},e:{r:3,c:1}, /* B1:B3 */},
              {s:{r:0,c:2},e:{r:3,c:2}  /* C1:C3 */},
              {s:{r:0,c:3},e:{r:1,c:19}  /* D1:T2 */},
              {s:{r:2,c:5},e:{r:2,c:7}  /* F3:H3 */},
              {s:{r:2,c:12},e:{r:2,c:15}  /* M3:P3 */},
              {s:{r:2,c:16},e:{r:2,c:18}  /* Q3:S3 */},
              {s:{r:2,c:19},e:{r:3,c:19}  /* T3:T4 */},
              {s:{r:0,c:20},e:{r:3,c:20}  /* U1:U4 */},
              {s:{r:0,c:21},e:{r:3,c:21}  /* V1:V4 */},
              {s:{r:0,c:22},e:{r:3,c:22}  /* W3:W4 */},
              {s:{r:0,c:23},e:{r:3,c:23}  /* X3:X4 */},
              {s:{r:0,c:24},e:{r:1,c:26}  /* Y1:AA2 */},
              {s:{r:2,c:24},e:{r:3,c:24}  /* Y3:Y4 */},
              {s:{r:2,c:25},e:{r:2,c:26}  /* Z3:AA3 */},              
              {s:{r:0,c:27},e:{r:2,c:28}  /* AB1:AC3 */},              
              {s:{r:0,c:29},e:{r:0,c:46}  /* AD1:AU3 */},              
              {s:{r:1,c:29},e:{r:1,c:36}  /* AD2:AK2 */},              
              {s:{r:2,c:29},e:{r:2,c:33}  /* AD3:AH3 */},              
              {s:{r:2,c:36},e:{r:3,c:36}  /* AK3:AK4 */},              
              {s:{r:2,c:34},e:{r:2,c:35}  /* AI3:AJ3*/},          
              {s:{r:1,c:37},e:{r:3,c:37}  /* AL2:AL4*/},    
              
              {s:{r:1,c:38},e:{r:1,c:40}  /* AM2:AO2*/},    
              {s:{r:2,c:38},e:{r:3,c:38}  /* AM3:AM4*/},    
              {s:{r:2,c:39},e:{r:2,c:40}  /* AN3:AO3*/},    

              {s:{r:2,c:41},e:{r:3,c:41}  /* AP3:AP4*/},    
              {s:{r:2,c:42},e:{r:3,c:42}  /* AQ3:AQ4*/},    

              {s:{r:1,c:43},e:{r:3,c:43}  /* AR2:AR4*/},    
              {s:{r:1,c:44},e:{r:3,c:44}  /* AS2:AS4*/},    
              {s:{r:1,c:45},e:{r:3,c:45}  /* AT2:AT4*/},    
              {s:{r:1,c:46},e:{r:3,c:46}  /* AU2:AU4*/},    
            ]
          }
        }
      };



      var items = [];
      if (json.scenes && json.scenes.scene){
        for (var k in json.scenes.scene){
          var scene = json.scenes.scene[k];
          items.push(['START']);
          items.push(['content','message']);

          if (scene && scene.items && scene.items.item){
            for (var m in scene.items.item){
              var item = scene.items.item[m];

              var primary_media = null;
              var secondary_media = null;
              
              if (item.hasOwnProperty('media')){                
                if (item.media._attributes.type === 'image'||item.media._attributes.type === 'video'){
                  primary_media = item.media._attributes.type;
                }
                if (item.media._attributes.secondaryType === 'image'||item.media._attributes.secondaryType === 'video'){
                  secondary_media = item.media._attributes.secondaryType;
                }
              }
              else if (item.sound && item.sound.enabled){
                primary_media = 'sound';
              }
                          
              if (item.text && item.text._attributes && item.text._attributes.size){
                if (item.text._attributes.size === 'small'){
                  item.text._attributes.size = 18;
                }
                else if (item.text._attributes.size === 'medium'){
                  item.text._attributes.size = 22;
                }
                else if (item.text._attributes.size === 'large'){
                  item.text._attributes.size = 26;
                }
                else if (item.text._attributes.size === 'xlarge'){
                  item.text._attributes.size = 30;
                }
              }

              if (item.name && item.name._attributes && item.name._attributes.size){
                if (item.name._attributes.size === 'small'){
                  item.name._attributes.size = 18;
                }
                else if (item.name._attributes.size === 'medium'){
                  item.name._attributes.size = 22;
                }
                else if (item.name._attributes.size === 'large'){
                  item.name._attributes.size = 26;
                }
                else if (item.name._attributes.size === 'xlarge'){
                  item.name._attributes.size = 30;
                }
              }                  

              items.push([
                item._attributes.type,
                item._attributes.style,
                item._attributes.position && item._attributes.position.toUpperCase(),                
                item.name && item.name.enabled && item.name._text,
                (item.text && item.text.enabled && item.text._text)?item.text._text:"　　　",
                (item.url)?item.url:'',
                (item.url)?'TRUE':'',
                (item.url)?'#00ff00':'',
                (primary_media === 'image' || primary_media === 'video')?primary_media:'',  //if sound "sound"
                (primary_media === 'image' || primary_media === 'video')?item.media._attributes.src:'', //if sound item.sound._attributes.src                
                (secondary_media === 'image' || secondary_media === 'video')?secondary_media:'', //if sound 
                (secondary_media === 'image' || secondary_media === 'video')?item.media._attributes.secondarySrc:'', //if sound item.sound._attributes.src
                (secondary_media === 'image' || secondary_media === 'video')?'':(item.text && item.text._attributes && item.text._attributes.style)  ||  '',
                (secondary_media === 'image' || secondary_media === 'video')?'':(item.text && item.text._attributes && item.text._attributes.size)  ||  '',
                (secondary_media === 'image' || secondary_media === 'video')?'':(item.text && item.text._attributes && item.text._attributes.color)  || '',
                (secondary_media === 'image' || secondary_media === 'video')?'':(item.text && item.text._attributes && item.text._attributes.anim)  ||  '',

                (secondary_media === 'image' || secondary_media === 'video')?'':(item.name && item.name._attributes && item.name._attributes.style)  ||  '',
                (secondary_media === 'image' || secondary_media === 'video')?'':(item.name && item.name._attributes && item.name._attributes.size)  ||  '',
                (secondary_media === 'image' || secondary_media === 'video')?'':(item.name && item.name._attributes && item.name._attributes.color)  ||  '' ,

                (item._attributes && item._attributes.itemColor)   ||   '' ,
                //(item._attributes && item._attributes.anim ? 'fade' : '')   ||   '' ,
                (item._attributes && item._attributes.anim)   ||   '' ,
                (item._attributes && item._attributes.vibration ? 'y' : '')   ||   '' ,
                (item._attributes && item._attributes.allowSkip === 'true' ? 'y' : '')   ||   '' ,
                (item._attributes && item._attributes.autoDismiss === 'true' ? 'y' : '')   ||   '' ,

                (!item.bg || !item.bg.enabled) ? ''  :  (item.bg._attributes.color)  ,
                (!item.bg || !item.bg.enabled) ? ''  :  (item.bg._attributes.color ? 'color' : item.bg._attributes.type)  ,
                (!item.bg || !item.bg.enabled) ? ''  :  (item.bg._attributes.color ? item.bg._attributes.color : item.bg._attributes.src)  ,

                (!item.sound || !item.sound.enabled) ? ''  :  (item.sound._attributes.src)  ,
                (!item.sound || !item.sound.enabled) ? ''  :  (item.sound._attributes.loop)  ,

              ]);
                

              
                

                /* ignore overlay for now
                ${ (!item.overlay ) ? `
                  <td>
                  </td>
                  <td>
                  </td>
                  <td>
                  </td>
                  <td>
                  </td>
                  <td>
                  </td>
                  `  :  `
                  <td>${item.text && item.text.enabled && item.text._text}</td>
                  <td>${item.text && item.text._attributes && item.text._attributes.style}</td>
                  <td>${item.text && item.text._attributes && item.text._attributes.size}</td>
                  <td>${item.text && item.text._attributes && item.text._attributes.color}</td>
                  <td>${item.text && item.text._attributes && item.text._attributes.anim}</td>
                `}
                  
                  
                  
                
                ${ (!item.overlay || !item.overlay.media || !item.overlay.media._attributes ) ? `
                  <td>
                  </td>
                  <td>
                  </td>
                  `  :  `
                  <td>${item.overlay.media._attributes && item.overlay.media._attributes.type}</td>
                  <td>${item.overlay.media._attributes && item.overlay.media._attributes.src}</td>
                `}
                                      
                                      
                                      
                ${ (!item.overlay ) ? `
                  <td>
                  </td>
                  <td>
                  </td>
                  `  :  `
                  <td>${item.overlay._attributes && item.overlay._attributes.position}</td>
                  <td>${item.overlay._attributes && item.overlay._attributes.anim}</td>
                `}
                
                
                                      
                ${ (!item.overlay ) ? `
                  <td>
                  </td>
                  <td>
                  </td>
                  <td>
                  </td>
                  <td>
                  </td>
                  <td>
                  </td>
                  `  :  `
                  <td>${ (!item.bg || !item.bg.enabled) ? ''  :  (item.bg._attributes.color)  }</td>
                  <td>${ (!item.bg || !item.bg.enabled) ? ''  :  (item.bg._attributes.color ? 'color' : item.bg._attributes.type)  }</td>
                  <td>${ (!item.bg || !item.bg.enabled) ? ''  :  (item.bg._attributes.color ? item.bg._attributes.color : item.bg._attributes.src)  }</td>

                  <td>${ (!item.sound || !item.sound.enabled) ? ''  :  (item.sound._attributes.src)  }</td>
                  <td>${ (!item.sound || !item.sound.enabled) ? ''  :  (item.sound._attributes.loop)  }</td>

                `}
                
                
                
                                      
                ${ (!item.overlay ) ? `
                  <td>
                  </td>
                  <td>
                  </td>
                  <td>
                  </td>
                  <td>
                  </td>
                  `  :  `
                  <td>${item.overlay._attributes && item.overlay._attributes.vibration ? 'y' : ''}</td>
                  <td>${item.overlay._attributes && item.overlay._attributes.timing ? 'fade' : ''}</td>
                  <td>${item.overlay._attributes && item.overlay._attributes.allowSkip === 'true' ? 'y' : ''}</td>
                  <td>${item.overlay._attributes && item.overlay._attributes.autoDismiss === 'true' ? 'y' : ''}</td>
                `}
                  
                </tr>
              `)
              */
            }
          }
          items.push(['END']);
        }
      }
          
        /*items.push(['START']);
        items.push(['content','message']);
        items.push(['END']);*/

        //console.log(items);
        for (var i = 0; i < items.length; i++) {
          XLSX.utils.sheet_add_aoa(wb.Sheets.Sheet1, [
            items[i]
          ], {origin: -1});                  
        }                
        

      if (global.DEBUG){console.log(projectName)}
      
    var wopts = { bookType:'xlsx', bookSST:true, type:'array' };

    var wbout = XLSX.write(wb,wopts);

    zip.file(projectName+"___.xlsx", wbout); 
      
      
      //XLSX.writeFile(wb, projectName+'___.xlsx');
  }
}
